import { render, staticRenderFns } from "./search-approver.vue?vue&type=template&id=26ec054b&scoped=true"
import script from "./search-approver.ts?vue&type=script&lang=ts&external"
export * from "./search-approver.ts?vue&type=script&lang=ts&external"
import style0 from "./search-approver.vue?vue&type=style&index=0&id=26ec054b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ec054b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26ec054b')) {
      api.createRecord('26ec054b', component.options)
    } else {
      api.reload('26ec054b', component.options)
    }
    module.hot.accept("./search-approver.vue?vue&type=template&id=26ec054b&scoped=true", function () {
      api.rerender('26ec054b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/form-approval-workflow/search-approver/search-approver.vue"
export default component.exports